/**
 * 開発建設部/都道府県コードの画面用文字列リスト
 */
const PREFECTURE_LIST = [
  { num: "01", name: "札幌" },
  { num: "02", name: "函館" },
  { num: "03", name: "小樽" },
  { num: "04", name: "旭川" },
  { num: "05", name: "室蘭" },
  { num: "06", name: "釧路" },
  { num: "07", name: "帯広" },
  { num: "08", name: "網走" },
  { num: "09", name: "留萌" },
  { num: "10", name: "稚内" },
  { num: "21", name: "岐阜県" },
  { num: "22", name: "静岡県" },
  { num: "23", name: "愛知県" },
  { num: "24", name: "三重県" },
];
/**
 * 停電フラグの画面用文字列リスト
 */
const BREAKOUT_FLAG_LIST = [
  { num: "0", name: "通常" },
  { num: "1", name: "停電" },
];
/**
 * ループ異常フラグの画面用文字列リスト
 */
const LOOP_FLAG_LIST = [
  { num: "0", name: "通常" },
  { num: "1", name: "異常" },
];
/**
 * 上り・超音波異常の画面用文字列リスト
 */
const ULTRASONIC_FLAG_LIST = [
  { num: "0", name: "通常" },
  { num: "1", name: "異常" },
];
/**
 * 欠測フラグの画面用文字列リスト
 */
const MISSING_FLAG_LIST = [
  { num: "0", name: "通常" },
  { num: "1", name: "欠測" },
];
/**
 * デコード映像から映像解析機能への取り込み加工処理
 */
// const IMPORTING_FAILURE_FLAG_LIST = [
//   { num: "0", name: "通常" },
//   { num: "1", name: "異常" },
// ];
/**
 * 地方整備局コードの画面用文字列リスト
 */
const REGIONAL_BUREAU_LIST = [
  { num: 81, name: "北海道開発局" },
  { num: 82, name: "東北地方整備局" },
  { num: 83, name: "関東地方整備局" },
  { num: 84, name: "北陸地方整備局" },
  { num: 85, name: "中部地方整備局" },
  { num: 86, name: "近畿地方整備局" },
  { num: 87, name: "中国地方整備局" },
  { num: 88, name: "四国地方整備局" },
  { num: 89, name: "九州地方整備局" },
  { num: 90, name: "沖縄総合事務局" },
];
/**
 * 収集時間フラグの画面用文字列リスト
 */
const COLLECT_TIME_FLAG_LIST = [
  { num: "1", name: "5分間" },
  { num: "2", name: "1時間" },
];
/**
 * カメラプリセット位置の画面用文字列リスト
 */
const COAMERA_PRESET_FLAG_LIST = [
  { num: "0", name: "正常" },
  { num: "1", name: "異常" },
];
/**
 * 無・有の画面用文字列リスト
 */
const VALID_FLAG_LIST = [
  { num: "0", name: "無" },
  { num: "1", name: "有" },
];
/**
 * 5分欠測処理フラグの画面用文字列リスト
 */
const FIVE_MIN_MISSING_LIST = [
  { num: "0", name: "処理不要" },
  { num: "1", name: "5分間値による拡大" },
  { num: "2", name: "5分間値不足により欠測扱い" },
];
/**
 * 一時間確定値欠測フラグの画面用文字列リスト
 */
const MISSING_PROC_LIST = [
  { num: "0", name: "非処理値" },
  { num: "1", name: "5分間ごとの欠測処理値" },
  { num: "2", name: "1時間欠測処理値" },
  { num: "3", name: "1日欠測処理値" },
];
/**
 * 一時間確定値（画像認識型）欠測フラグの画面用文字列リスト
 */
const IMAGE_MISSING_PROC_LIST = [
  { num: "0", name: "非処理値" },
  { num: "1", name: "5分間ごとの欠測処理値" },
  { num: "2", name: "1時間欠測処理値" },
  { num: "3", name: "片側補完" },
  { num: "4", name: "上下とも1日欠測処理" },
];
/**
 * 特異値の画面用文字列リスト
 */
const SINGULAR_LIST = [
  { num: "0", name: "非処理値" },
  { num: "1", name: "非処理値（広域な特異日で特異値でなくなった値）" },
  { num: "2", name: "特異値" },
];
/**
 * 車種不明配分の画面用文字列リスト
 */
const UNKNOWN_CAR_LIST = [
  { num: "0", name: "車種不明配分なし" },
  { num: "1", name: "車種不明配分あり" },
];
/**
 * 精度ケースの画面用文字列リスト
 */
const ACCURACY_LIST = [
  { num: "1", name: "ケース1" },
  { num: "2", name: "ケース2" },
  { num: "3", name: "ケース3" },
  { num: "4", name: "ケース4" },
  { num: "5", name: "ケース5" },
];
/**
 * TraVos基本区間の区間別フラグの画面用文字列リスト
 */
const SECTORL_DENTIFICATION_LIST = [
  { num: "1", name: "一般道路常時観測区間（観測区間）" },
  { num: "2", name: "一般道路常時観測区間（非観測区間）" },
  { num: "3", name: "一般道路推定区間（観測区間）" },
  { num: "4", name: "一般道路推定区間（非観測区間）" },
  { num: "5", name: "高速道路常時観測区間（観測区間）" },
  { num: "6", name: "高速道路常時観測区間（非観測区間）" },
  { num: "7", name: "一般道路常時観測区間（画像・観測区間）" },
  { num: "8", name: "一般道路常時観測区間（画像・非観測区間）" },
];
/**
 * TraVos基本区間の曜日コードの画面用文字列リスト
 */
const WEEK_LIST = [
  { num: "1", name: "月" },
  { num: "2", name: "火" },
  { num: "3", name: "水" },
  { num: "4", name: "木" },
  { num: "5", name: "金" },
  { num: "6", name: "土" },
  { num: "7", name: "日" },
];
/**
 * TraVos基本区間の平日・休日コードの画面用文字列リスト
 */
const WEEKDAY_AND_HOLIDAY_LIST = [
  { num: "1", name: "平日" },
  { num: "2", name: "休日" },
];
/**
 * 観測方向のフラグの画面用文字列リスト
 */
const DIRECTION_LIST = [
  { num: "1", name: "上下" },
  { num: "2", name: "上りのみ" },
  { num: "3", name: "下りのみ" },
];
/**
 * 観測フラグの画面用文字列リスト
 */
const OBSERVAT_FLAG_LIST = [
  { num: "1", name: "基準交通量がH17センサス値" },
  { num: "2", name: "基準交通量がH22センサス値" },
  { num: "3", name: "基準交通量がその他の観測値" },
  { num: "4", name: "基準交通量がH27センサス値" },
  { num: "5", name: "基準交通量がR3センサス値" },
];

export class TraVosCodeUtil {
  /**
   * 開発建設部/都道府県コードを画面用文字列に変換する
   */
  public static toPrefectureCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const prefecture = PREFECTURE_LIST.find((element) => element.num === code);
    if (!prefecture) {
      return code + "（未定義）";
    } else {
      return prefecture.num + "（" + prefecture.name + "）";
    }
  }
  /**
   * 停電フラグを画面用文字列に変換する
   */
  public static toTraVosBreakoutCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const BreakoutFlag = BREAKOUT_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!BreakoutFlag) {
      return code + "（未定義）";
    } else {
      return BreakoutFlag.num + "（" + BreakoutFlag.name + "）";
    }
  }
  /**
   * ループ異常フラグを画面用文字列に変換する
   */
  public static toLoopCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const loopFlag = LOOP_FLAG_LIST.find((element) => element.num === code);
    if (!loopFlag) {
      return code + "（未定義）";
    } else {
      return loopFlag.num + "（" + loopFlag.name + "）";
    }
  }
  /**
   * 上り・超音波異常を画面用文字列に変換する
   */
  public static toUltrasonicCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const ultrasonicFlag = ULTRASONIC_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!ultrasonicFlag) {
      return code + "（未定義）";
    } else {
      return ultrasonicFlag.num + "（" + ultrasonicFlag.name + "）";
    }
  }
  /**
   * 欠測フラグを画面用文字列に変換する
   */
  public static toMissingCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const missingicFlag = MISSING_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!missingicFlag) {
      return code + "（未定義）";
    } else {
      return missingicFlag.num + "（" + missingicFlag.name + "）";
    }
  }
  /**
   * 地方整備局コードを画面用文字列に変換する
   */
  public static toRegionalBureauViewString(code: number) {
    if (!code) {
      return "-";
    }
    const regionalBureau = REGIONAL_BUREAU_LIST.find(
      (element) => element.num === code
    );
    if (!regionalBureau) {
      return code + "（未定義）";
    } else {
      return regionalBureau.num + "（" + regionalBureau.name + "）";
    }
  }
  /**
   * 収集時間フラグを画面用文字列に変換する
   */
  public static toCollectTimeCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const collectTimeFlag = COLLECT_TIME_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!collectTimeFlag) {
      return code + "（未定義）";
    } else {
      return collectTimeFlag.num + "（" + collectTimeFlag.name + "）";
    }
  }
  /**
   * カメラプリセット位置を画面用文字列に変換する
   */
  public static toCameraPresetsCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const coameraPresetsFlag = COAMERA_PRESET_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!coameraPresetsFlag) {
      return code + "（未定義）";
    } else {
      return coameraPresetsFlag.num + "（" + coameraPresetsFlag.name + "）";
    }
  }
  /**
   * 無・有を画面用文字列に変換する
   */
  public static toValidCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const validFlag = VALID_FLAG_LIST.find((element) => element.num === code);
    if (!validFlag) {
      return code + "（未定義）";
    } else {
      return validFlag.num + "（" + validFlag.name + "）";
    }
  }
  /**
   * 5分欠測処理フラグを画面用文字列に変換する
   */
  public static toFiveMinMissingViewString(code: string) {
    if (!code) {
      return "-";
    }
    const fiveMinMissingProcFlag = FIVE_MIN_MISSING_LIST.find(
      (element) => element.num === code
    );
    if (!fiveMinMissingProcFlag) {
      return code + "（未定義）";
    } else {
      return (
        fiveMinMissingProcFlag.num + "（" + fiveMinMissingProcFlag.name + "）"
      );
    }
  }
  /**
   * 一時間確定値欠測フラグを画面用文字列に変換する
   */
  public static toMissingProcCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const missingProcFlag = MISSING_PROC_LIST.find(
      (element) => element.num === code
    );
    if (!missingProcFlag) {
      return code + "（未定義）";
    } else {
      return missingProcFlag.num + "（" + missingProcFlag.name + "）";
    }
  }
  /**
   * 一時間確定値（画像認識型）欠測フラグを画面用文字列に変換する
   */
  public static toImageMissingProcCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const imageMissingProcFlag = IMAGE_MISSING_PROC_LIST.find(
      (element) => element.num === code
    );
    if (!imageMissingProcFlag) {
      return code + "（未定義）";
    } else {
      return imageMissingProcFlag.num + "（" + imageMissingProcFlag.name + "）";
    }
  }
  /**
   * 特異値を画面用文字列に変換する
   */
  public static toSingularCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const singularFlag = SINGULAR_LIST.find((element) => element.num === code);
    if (!singularFlag) {
      return code + "（未定義）";
    } else {
      return singularFlag.num + "（" + singularFlag.name + "）";
    }
  }
  /**
   * 車種不明配分を画面用文字列に変換する
   */
  public static toUnknownCarCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const unknownCarFlag = UNKNOWN_CAR_LIST.find(
      (element) => element.num === code
    );
    if (!unknownCarFlag) {
      return code + "（未定義）";
    } else {
      return unknownCarFlag.num + "（" + unknownCarFlag.name + "）";
    }
  }
  /**
   * 精度ケースを画面用文字列に変換する
   */
  public static toAccuracyCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const accuracyFlag = ACCURACY_LIST.find((element) => element.num === code);
    if (!accuracyFlag) {
      return code + "（未定義）";
    } else {
      return accuracyFlag.num + "（" + accuracyFlag.name + "）";
    }
  }
  /**
   * TraVos基本区間の区間別フラグを画面用文字列に変換する
   */
  public static toSectorldentification(code: string) {
    if (!code) {
      return "-";
    }
    const sectorldentificationFlag = SECTORL_DENTIFICATION_LIST.find(
      (element) => element.num === code
    );
    if (!sectorldentificationFlag) {
      return code + "（未定義）";
    } else {
      return (
        sectorldentificationFlag.num +
        "（" +
        sectorldentificationFlag.name +
        "）"
      );
    }
  }
  /**
   * TraVos基本区間の曜日コードを画面用文字列に変換する
   */
  public static toDayOfWeek(code: string) {
    if (!code) {
      return "-";
    }
    const weekCode = WEEK_LIST.find((element) => element.num === code);
    if (!weekCode) {
      return code + "（未定義）";
    } else {
      return weekCode.num + "（" + weekCode.name + "）";
    }
  }
  /**
   * TraVos基本区間の平日・休日コードを画面用文字列に変換する
   */
  public static toWeekdayAndHoliday(code: string) {
    if (!code) {
      return "-";
    }
    const weekdayAndHolidayCode = WEEKDAY_AND_HOLIDAY_LIST.find(
      (element) => element.num === code
    );
    if (!weekdayAndHolidayCode) {
      return code + "（未定義）";
    } else {
      return (
        weekdayAndHolidayCode.num + "（" + weekdayAndHolidayCode.name + "）"
      );
    }
  }
  /**
   * 観測方向のフラグを画面用文字列に変換する
   */
  public static toDirectionCodeViewString(code: string) {
    if (!code) {
      return "-";
    }
    const directionCode = DIRECTION_LIST.find(
      (element) => element.num === code
    );
    if (!directionCode) {
      return code + "（未定義）";
    } else {
      return directionCode.num + "（" + directionCode.name + "）";
    }
  }
  /**
   * 観測フラグを画面用文字列に変換する
   */
  public static toObservationFlagsString(code: string) {
    if (!code) {
      return "-";
    }
    const observationFlag = OBSERVAT_FLAG_LIST.find(
      (element) => element.num === code
    );
    if (!observationFlag) {
      return code + "（未定義）";
    } else {
      return observationFlag.num + "（" + observationFlag.name + "）";
    }
  }
}
